import * as React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'formik'
import { LogoSpinner } from 'shared'

// using an inner class component because functions in a functional component
// would capture the current formik state, breaking sleepUntilSubmitted().
export const PaypalButton = connect(class extends React.Component {
  createOrderOrBillingAgreement = async (_data, _actions) => {
    this.props.formik.submitForm()
    await this.sleepUntilSubmitted()

    // form submission is done, but keep looking busy while waiting for redirect.
    this.props.formik.isValid && this.props.formik.setSubmitting(true)

    // paypal can handle different tokens being returned here (payment, billing agreement)
    return this.props.formik.values._paypal_token
  }

  sleepUntilSubmitted = async () => {
    const sleep = async (ms) => new Promise(resolve => setTimeout(resolve, ms))
    while (this.props.formik.isSubmitting) { await sleep(100) }
  }

  onApprove = (_data, _actions) => {
    window.location = this.props.formik.values._redirect_to
  }

  render = () => {
    // window['paypal'] would also find our payment_method dom element via id :sad:
    const paypal = window.hasOwnProperty('paypal') && window['paypal']
    if (!paypal) return <NoPaypalJsMessage />

    const Button = paypal.Buttons.driver('react', { React, ReactDOM })
    const { isSubmitting } = this.props.formik

    return <div style={containerStyle}>
      {isSubmitting && <DummyButtonWithSpinner height={buttonHeight} />}

      <div style={isSubmitting ? { display: 'none' } : {}}>
        <Button
          commit
          env={this.props.formik.values._debug ? 'sandbox' : 'production'}
          createBillingAgreement={this.createOrderOrBillingAgreement}
          onApprove={this.onApprove}
          onCancel={() => this.props.formik.setSubmitting(false)}
          onError={() => this.props.formik.setSubmitting(false)}
          style={buttonStyle}
        />
      </div>
    </div>
  }
})

const DummyButtonWithSpinner = ({ height }) =>
  <div style={{ height, margin: 0, paddingTop: 12, textAlign: 'center' }}>
    <LogoSpinner />
  </div>

const NoPaypalJsMessage = () =>
  <p className='generic-value negative'>
    {I18n.t('donate.submit_button.no_paypal_js_notice')}
  </p>

// prettier-ignore

const containerStyle = {
  minWidth: 200,
  maxWidth: 300,
  background: '#f6c439',
  borderRadius: 4,
  boxShadow: '2px 2px 3px grey',
  lineHeight: '10px',
}

const buttonHeight = 50

const buttonStyle = {
  height: buttonHeight,
  color: 'gold',
  fundingicons: false,
  label: 'checkout',
  shape: 'rect',
  size: 'responsive',
  tagline: false,
}
